import React from 'react';
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material';
import { CheckboxSize, CheckboxColor } from '../../../config/checkbox';

export interface CheckboxProps
  extends Omit<MuiCheckboxProps, 'size' | 'color'> {
  size?: CheckboxSize | MuiCheckboxProps['size'];
  color?: CheckboxColor | MuiCheckboxProps['color'];
}

export const Checkbox: React.FC<CheckboxProps> = ({
  size = 'medium',
  color = 'primary',
  ...props
}) => {
  return <MuiCheckbox size={size} color={color} {...props} />;
};
